import type { FaireProductEntity } from "../../entity_types/product";

export const p_jvkff446cp: FaireProductEntity = {
  token: "p_jvkff446cp",
  type: "product",
  name: "Onyx 15 oz. Tiki",
  brandName: "Hospitality Glass",
  imageUrl:
    "https://cdn.faire.com/fastly/87e473a145c57b5a8ee16b9d5217923d12d720c43c13568a9b7517e445c74142.webp",
  priceDollars: 7.1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/22255ec01b6063498142712f464e8195d3c0edb4be71cb3d49d77738ac1be22d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
